import $ from 'jquery';
import "jquery-mousewheel";
import 'malihu-custom-scrollbar-plugin';
import {throttle} from './lib';

let $wrapper,
    $window,
    $body,
    init = false,
    configScrollbar = {
        scrollbarPosition: 'outside',
        snapOffset: 100,
        mouseWheelPixels: 250,
        scrollInertia: 1000,
        callbacks: {
            whileScrolling: onScroll
        }
    },
    header = {
        cl: 'b-top-menu_black',
        $el: null,
        offset: 400
    },
    params = {
        $el: null
    },
    widget = {
        top: 772,
        offsetTop: 110,
        padding: 110,
        wayLength: 300,
        $el: null
    },
    mobileWidth = 1244,
    customScrollBar;

function start(params) {
    $window = $(window);
    $wrapper = $('.wrapper');
    $body = $('body');
    mobileWidth = params.mobileWidth || mobileWidth;
    initBlocks();
    header.$el = $(`.${header.cl}`);

    testMobile();
    $window.on('resize', throttle(testMobile, 500))
}

function testMobile() {
    if (window.innerWidth > mobileWidth && !init) {
        initCustomScrollbar();
        init = true;
    } else if (window.innerWidth <= mobileWidth && init) {
        destroyCustomScrollbar();
        widget.$el.css({top: 0});
        init = false;
    }
}

function initCustomScrollbar() {
    let h = $window.height();

    $body.css('overflow', 'hidden');
    customScrollBar = $wrapper.height(h)
        .mCustomScrollbar(configScrollbar);
    addHandlers();
    widgetInit();
}

function destroyCustomScrollbar() {
    $body.css('overflow', 'auto');
    $wrapper.mCustomScrollbar('destroy');
    removeHandlers();
}

function widgetInit() {
    widget.$el = $('.c-widget');
    widget.topTrigger = widget.top - widget.offsetTop;
    widget.bottomTrigger = $('.mCSB_container').height() - $('.footer').height() - widget.$el.height() - widget.padding;
}

function addHandlers() {
    removeHandlers();
    $window.on('resize', resize);
    $body.on('closeGallery', closeGallery);
}

function removeHandlers() {
    $window.off('resize', resize);
    $body.off('closeGallery', closeGallery);
}

function resize() {
    $wrapper.height($window.height());
}

function closeGallery() {
    params.$el.css({top: 0});
}

function onScroll() {
    let top = Math.abs(this.mcs.top),
        offset = getOffset(top);

    checkHeader(top);

    if (offset) {
        params.$el.css({top: offset});
    }

    setOffsetWidget(top);
}

function getOffset(top) {
    let offset = 0,
        index;

    for (index in params.periods) {

        if (top >= params.periods[index].start && top <= params.periods[index].stop) {
            offset += top - params.periods[index].start;
            return offset;
        } else {
            offset += params.periods[index].stop - params.periods[index].start;
        }
    }

    return 0;
}

function setOffsetWidget(top) {
    let offset;

    if (top >= widget.topTrigger && top < widget.bottomTrigger && widget.fixed !== true) {
        widget.fixed = true;
        widget.$el.css({top: widget.offsetTop});
    } else if (top < widget.topTrigger) {
        widget.fixed = false;
        offset = widget.top - top;
        widget.$el.css({top: offset});
    } else if (top >= widget.bottomTrigger) {
        widget.fixed = false;
        offset = widget.bottomTrigger - top + widget.offsetTop;
        widget.$el.css({top: offset});
    }
}

function checkHeader(top) {
    if (top >= header.offset) {
        $body.addClass('show');
    } else {
        $body.removeClass('show');
    }
}

function block1(top, el) {
    if (top >= el.y1 && el.state === 1) {
        el.state = 2;
    } else if (top < el.y1 && el.state > 1) {
        el.top = top + el.offset;
        el.state = 1;
    }

    if (top >= el.y2 && el.state === 2) {
        el.state = 3;
        el.top = top + el.offset;
    } else if (top <= el.y2 && top > el.y1 && el.state === 3) {
        el.state = 2;
    }

    if (el.state === 1 || el.state === 3) {
        let ftop = el.top - top;
        el.$el.css({top: ftop});
    }

}


function initBlocks() {
    let $el = $('.o-sticky'),
        p = $el.data('params');

    if (p) {
        params.$el = $el;
        params.periods = p.periods;
    }
}

export default {
    start
}


// WEBPACK FOOTER //
// ./modules/paralaxv2.1.js